<template>
    <!-- <div class="" style="padding-bottom: 20px;"> -->
    <div class="events-home-list">
        <div class="page-title">
            <div class="title">Events</div>
            <el-button
                v-if="shrinked"
                class="zoom-button"
                icon="el-icon-zoom-in"
                @click="focus"
            ></el-button>
        </div>
        <gcmcn-filters
            v-show="!shrinked"
            ref="gcmcn-filters"
            :filter-values="[selectedSortType, searchFilter, selectedUniversesForFilter, selectedEntitiesForFilter]"
            @reset-filters="resetFilters"
            @hook:mounted="computeFilterHeight"
        >
            <dropdown
                name="Sort"
                :multiple="false"
                :list="$store.getters.sortTypeList"
                itemName="name"
                itemValue="value"
                :itemsSelected="selectedSortType.length > 0 ? [selectedSortType] : []"
                @on-select-item="selectedSortType = $event"
            ></dropdown>
            <dropdown
                name="Entities"
                :multiple="true"
                :list="$store.getters.entities"
                itemName="display_name"
                itemValue="uid"
                :itemsSelected="selectedEntitiesForFilter"
                @on-select-item="onSelectEntity"
            ></dropdown>
            <dropdown
                name="Universes"
                :multiple="true"
                :list="filteredUniverses"
                itemName="name"
                itemValue="uid"
                :itemsSelected="selectedUniversesForFilter"
                @on-select-item="onSelectUniverses"
            ></dropdown>
            <search-filter ref="search" @new-value="searchFilter = $event"></search-filter>
        </gcmcn-filters>
        <div v-show="!shrinked">
            <div
                v-if="filteredEvents.length > 0"
                style="overflow-y: scroll;padding-right: 3px;"
                :style="{height: `calc(100vh - (${usedHeight}px)`}"
            >
                <event
                    v-for="event in filteredEvents"
                    :key="event.uid"
                    :event="event"
                    :selectedEventUid="selectedEvent ? selectedEvent.uid : ''"
                    :universe="relatedUniverse(event)"
                    @changeSelectedEvent="onEventSelected"
                ></event>
            </div>
            <div v-else-if="events.length > 0" class="list-empty">
                No event(s) match this filters.
            </div>
            <div v-else class="list-empty">
                No event(s).
            </div>
        </div>
        <div v-if="shrinked && selectedEvent">
            <event
                :condensed="true"
                :event="selectedEvent"
                :selectedEventUid="selectedEvent.uid"
                :universe="relatedUniverse(selectedEvent)"
            ></event>
        </div>
    </div>
</template>

<script>

import {
    GcmcnFilters,
    Dropdown,
    SearchFilter ,
} from 'gcmcn-common';
import Event from './event-card.vue';
import { mapGetters } from 'vuex';
import LoadingTemplate from '../../partials/ns-loader-template.vue';
export default {

    components: {
        GcmcnFilters,
        Dropdown,
        SearchFilter ,
        Event,

    },

    props: {
        events: {
            type: Array,
            required: true,
        },
        universes: {
            type: Array,
            required: true,
        },
        focused: {
            type: Boolean,
            default: false
        }
    },

    data (){
        return {
            selectedSortType: 'asc',
            searchFilter: '',
            selectedEvent: null,
            usedHeight: 0
        };
    },
    watch: {
        windowWidth (){
            this.computeFilterHeight();
        },
        selectedEntitiesForFilter(){
            let filteredUniversesUid = this.filteredUniverses
            .map(universe=>{
                return  universe.uid;

            });
            let selectedUniverseUids = this.selectedUniversesForFilter.filter(uid =>{
                return filteredUniversesUid.includes(uid);
            });
            this.$store.commit('SET_UNIVERSES_FOR_FILTER', selectedUniverseUids);
        }
    },

    computed: {
        ...mapGetters([
            'universesByUid',
            'pageHeight',
            'windowWidth',
            'selectedUniversesForFilter',
            'selectedEntitiesForFilter'
        ]),
        shrinked() {
            return this.windowWidth <= 1024 && this.focused === false;
        },
        filteredUniverses(){
            if(this.selectedEntitiesForFilter.length > 0){
                let universes = [...this.universes];
                let filteredUniverses = universes.filter(universe=>{
                    return  this.selectedEntitiesForFilter.includes(universe.scopes.entity_uid);

                });
                return filteredUniverses;
            }
            return this.universes;
        },
        filteredEvents (){
            let events = this.events.slice();
            if(this.selectedSortType){
                events.sort((a, b) => a.name.localeCompare(b.name));
                if(this.selectedSortType === 'dsc'){
                    events.reverse();
                }
            }
            if(this.selectedEntitiesForFilter.length > 0){
                events = events.filter((event) => this.selectedEntitiesForFilter.includes(event.scopes.entity_uid));
            }
            if(this.searchFilter){
                events = events.filter((ev) => ev.name.toLowerCase().includes(this.searchFilter.toLowerCase()));
            }
            if(this.selectedUniversesForFilter.length > 0){
                events = events.filter((ev) => this.selectedUniversesForFilter.includes(ev.universe_uid));
            }
            return events;
        },
    },

    mounted (){
        this.computeFilterHeight();
    },

    methods: {
        focus() {
            this.$emit('removeFocus', ['feeds_list', 'takers_list']);
            this.$emit('setFocus', 'events_list');
        },
        computeFilterHeight() {
            if(this.$refs['gcmcn-filters']){
                const clientRect = this.$refs['gcmcn-filters'].$el.getBoundingClientRect();
                this.usedHeight = clientRect.top + clientRect.height + 10 + 32; // +10 par ce que l'element contient un margin, et les margin ne sont pas comptés dans la height d'un element
                // 32 -> on enleve la height du wrapper d'alerte de fundation
            }
        },
        resetFilters (){
            this.selectedSortType = '';
            this.$refs.search.clear();
            this.$store.commit('CLEAR_ALL_FILTERS');
        },
        relatedUniverse (event){
            return this.universes.find((u) => u.uid === event.universe_uid);
        },
        onEventSelected (eventUid){
            this.$set(this, 'selectedEvent', this.events.find((ev) => ev.uid === eventUid));
            this.$emit('changeSelectedEvent', this.selectedEvent);
        },
        onSelectUniverses (universes){
            this.$store.commit('SET_UNIVERSES_FOR_FILTER', universes);
        },
        onSelectEntity (entities){
            this.$store.commit('SET_ENTITIES_FOR_FILTER', entities);
        },
    },
};
</script>

<style lang="scss">
.events-home-list {
    .page-title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .zoom-button {
            background-color: #111;
            border-color: #111;
            color: #BBB;
            padding: 5px;
            font-size: 18px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Home/event-list.vue